module.exports = __webpack_public_path__ + "static/media/powered-by-botim-business.e6206d62.png";